<script lang="ts">
	import { onMount } from "svelte";
	import { swipe } from 'svelte-gestures';
	import { CarouselHelper } from "$lib/helpers/swipe.helper";
	import type { BasicContent } from "$lib/domain/basic-content.interface";

	export let data: BasicContent[] = [];
	export let title: string | '' = 'Our approach';

	let activeIndex = 0;
	const maxCount = data.length;
	const carouselHelper = CarouselHelper.getInstance(maxCount);

	onMount(() => {
			if (!window.matchMedia('(max-width: 1400px)').matches) {
					return;
			}

			carouselHelper.resetInterval();
			carouselHelper.indexStore.subscribe((index) => (activeIndex = Number(index)));
	});
</script>

<article class="block-bg">
	<div class="container section-wrapper flex-column">
		<div class="section-title">
			<h2>{@html title}</h2>
		</div>
		
		<div class="container-list">
			{#each data as approach}
				<article class="package">
					<h3 class="package-title">
						{@html approach.title}
					</h3>
					
					<p class="package-description">
						{@html approach.content}
					</p>
				</article>
			{/each}
		</div>
		
		<div
			class="carousel"
			use:swipe="{{ timeframe: 300, minSwipeDistance: 60, touchAction: 'pan-y' }}"
			on:swipe="{carouselHelper.handleSwipe}">
			{#each data as approach, i}
				<article class="carousel-item package" class:active="{activeIndex === i}">
					<h3 class="package-title">
						{@html approach.title}
					</h3>
					
					<p class="package-description">
						{@html approach.content}
					</p>
				</article>
			{/each}
		</div>
		
		<ol class="carousel-indicators">
			{#each Array(maxCount) as _, i}
				<li
					on:click="{() => carouselHelper.select(i)}"
					on:keydown="{() => carouselHelper.select(i)}"
					class:active="{i === activeIndex}">
					<div class="carousel-bullet">•</div>
				</li>
			{/each}
		</ol>
	</div>
</article>

<style lang="scss">
	@import '$styles/vars';

	.block-bg {
		padding-top: 60px;
		padding-bottom: 60px;
		background: url('/approach-block.webp') top/cover no-repeat;
	}

	.section-wrapper {
		color: $main-white;

		.package{
			border-radius: 12px;
			background: rgba(255, 255, 255, 0.05);
			backdrop-filter: blur(12px);
			padding: 36px 24px;
		  	&-title {
				 text-align: center;
				 font-size: 16px;
				 font-weight: 600;
			}
		}

		h2 {
			color: $main-white;
		}

		.container-list {
			width: 100%;
			display: grid;
			grid-template-columns: repeat(3, minmax(0, 1fr));
			margin-top: 48px;
			column-gap: 24px;
			box-sizing: border-box;

			article {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: flex-start;
				position: relative;

				h4 {

				}

				p {
					text-align: center;
				}
			}
		}
	}

	.carousel,
	.carousel-indicators {
		display: none;
	}

	@media (min-width: $portrait-phone-size) and (max-width: $tablet-size) {

		.section-wrapper {
			.package{
				padding: 36px 12px;
			}

			.container {
				&-list {
					display: flex;
					flex-direction: column;
					row-gap: 12px;
				}
			}
		}
	}

	@media (max-width: $portrait-phone-size) {

		.section-wrapper {
			.carousel {
				margin-top: 24px;
			}

			.package{
				padding: 24px 12px;
			}

			.container {
				&-list {
					display: none;
				}
			}
		}

		.carousel,
		.carousel-indicators {
			display: flex;
		}

      	.carousel-indicators {
			li {
			  	display: inline-block;

			  	&.active {
					.carousel-bullet {
						color: $green;
					}
				}
			}

			.carousel-bullet {
				color: $light-green;

				&:hover {
					color: $dark-grey;
				}
			}
      	}
	}
</style>
